import ClipperPlaceholder from './ClipperPlaceholder.jsx';

export default function NovedadesCambioDeCondicionDePago() {
  return (
    <ClipperPlaceholder title="Cambio de Condición de Pago" category="Novedades" />
  );
}
